import { render, staticRenderFns } from "./CurrentParticipants.vue?vue&type=template&id=fb34ad04&"
import script from "./CurrentParticipants.vue?vue&type=script&lang=js&"
export * from "./CurrentParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports